<template>
    <Teleport to="#payment-method-tabs-container">
        <div class="payment-modal__methods">
            <div class="payment-modal__method-tabs">
                <button v-for="method in visiblePaymentMethods"
                        :key="method.ID"
                        class="btn btn-default"
                        :class="{
                            'active': method.ID === selectedPaymentMethod?.ID,
                        }"
                        :disabled="!selectablePaymentMethods.includes(method)"
                        @click="selectPaymentMethod(method)">
                    {{ method.shortName }}
                    <template v-if="duplicatedShortNames.includes(method.shortName) && method.displayName">
                        ({{ method.displayName }})
                    </template>
                </button>
            </div>

            <!-- Display warning if the cart requires repeat billing and the selected method does not support it -->
            <!-- This selection sounds nonsensical, but is used by clients. See PROP-2584 -->
            <div v-if="showMethodDoesNotSupportRecurringPaymentWarning"
                 class="alert alert--small alert-warning">
                <i class="fa-solid fa-triangle-exclamation"></i>&nbsp;
                {{ l('PAYMENT.METHOD_DOES_NOT_SUPPORT_REPEAT_PAYMENT') }}
            </div>
        </div>
    </Teleport>

    <Teleport to="#payment-modal-left-col">
        <div v-if="hasPaymentMethodsDisabledDueToPayingBalance"
             class="alert alert-warning">
            <i class="fa-solid fa-triangle-exclamation"></i>&nbsp;
            {{ l('PAYMENT.METHODS_UNAVAILABLE_WHILE_PAYING_BALANCE') }}
        </div>

        <div v-if="hasPaymentMethodsDisabledDueToRepeatPaymentRequirement"
             class="alert alert-info">
            <i class="fa-solid fa-info-circle"></i>&nbsp;
            {{ l('PAYMENT.METHODS_UNAVAILABLE_FOR_REPEAT_PAYMENT') }}
        </div>
    </Teleport>
</template>

<script>

import PaymentPatterns from '@/lib/PaymentMethods/PaymentPatterns';
import { container } from '@/container';
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('cart', [
            'currentCartPaymentPattern',
        ]),

        ...mapState('payment', [
            'hasPaymentMethodsDisabledDueToPayingBalance',
            'hasPaymentMethodsDisabledDueToRepeatPaymentRequirement',
            'restrictToPaymentMethodRef',
            'selectablePaymentMethods',
            'selectedPaymentMethod',
            'visiblePaymentMethods',
        ]),

        duplicatedShortNames() {
            return this.visiblePaymentMethods
                .filter((paymentMethod) => {
                    return this.visiblePaymentMethods.filter(
                        (pm) => pm.shortName === paymentMethod.shortName,
                    ).length > 1;
                })
                .map((paymentMethod) => paymentMethod.shortName);
        },

        showMethodDoesNotSupportRecurringPaymentWarning() {
            return (
                // Current payment pattern is not single (one-off payment).
                this.currentCartPaymentPattern
                && this.currentCartPaymentPattern !== PaymentPatterns.SINGLE
                // and the selected method does not support recurring payment.
                && this.selectedPaymentMethod
                && !this.selectedPaymentMethod.supportsSubscriptions
            );
        },
    },

    methods: {
        selectPaymentMethod(paymentMethod) {
            if (container.paymentState.paymentModalCancelable === false) {
                // Cannot switch payment method while transaction is in progress.
                return;
            }

            container.cartService.setSelectedPaymentMethod(paymentMethod);
        },
    },
};
</script>
